import { useMutation } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';
import type { VlbSucheResponse } from '@/types/bestellung';

/**
 * Freitextsuche im VLB (#83, A23).
 *
 * useMutation wie beim Lookup, und hier mit noch mehr Grund: Die Suche
 * wird ausdruecklich ausgeloest — Enter oder Lupe —, nie beim Tippen.
 * Ein useQuery haenge am Suchbegriff und liefe bei jedem Zeichen erneut;
 * genau das soll nicht passieren, solange ungemessen ist, ob der VLB die
 * Suche anders abrechnet als den Lookup (A23.4).
 */
export function useVlbSuche() {
  return useMutation({
    mutationFn: (begriff: string) =>
      apiFetch<VlbSucheResponse>(`/vlb/suche.php?q=${encodeURIComponent(begriff)}`)
  });
}
